import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#FF8A00",
    },
    secondary: {
      main: "#0F1214",
    },
    warning: {
      main: "#FF8A00",
    },
    text: {
      primary: "#3D3D3D",
      secondary: "#8B8B8B",
    },
    info: {
      main: '#929398',
    },
    grey: {
      900: 'rgba(61, 61, 61, 0.3)',
    },
    actions: {},
    background: {
      default: "#F2F2F2",
      paper: "#ffffff",
    },
  },

  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#3D3D3D!important',
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255, 138, 0, 0.5)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FF8A00',
          }
        }
      }
    }
  },
});

export default theme;